const STATUSES_FR = {
  added: "Ajouté",
  archived: "Archivé",
  canceled: "Annulée",
  complete: "Complet",
  confirmed: "À venir",
  ended: "Terminée",
  expired: "Expiré",
  expires_soon: "Bientôt expiré",
  incomplete: "Incomplet",
  paid: "Payé",
  paymentToCome: "A payer",
  pending: "En attente",
  proposed: "Offre",
  refused: "Refusée",
  scheduled: "À traiter",
  sent: "À traiter",
  started: "En cours",
  to_add: "À ajouter",
  to_renew: "À renouveler",
  toAdd: "À ajouter",
  toCome: "À venir",
  toCorrect: "À corriger",
  toJustify: "À justifier",
  toPay: "À payer",
  up_to_date: "À jour",
  validated: "Validé",
  validationInProgress: "Validation en cours",
  waiting_for_confirmation: "À venir",
  waiting_for_validation: "En cours",
} as const;

export default STATUSES_FR;
